<template>
  <div>
    <div class="vx-card p-6">
      <div class="flex flex-wrap" style="font-size: 40px; justify-content: center;">
        PERSONEL TALEP YÖNETİMİ
      </div>

      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow"></div>
        <div style="cursor: pointer; width: 100px; margin-top: 10px;" class="px-4 py-1 flex items-center">
          <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
          <JsonExcel :data="hrManagementList" class><b>İndir</b></JsonExcel>
        </div>
        <div class="vx-row justify-end flex">
          <div class="vx-col ml-5">
            <vs-button style="margin-top: 10px;" @click.stop="getHRManagementList()">Ara</vs-button>
          </div>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col md:w-1/5 w-full">
          <label class="text-sm"><b>Durum</b></label>
          <v-select @input="getHRManagementList()" class="w-full" placeholder="Durum" label="statusName" :options="statusList" v-model="searchModel.status" :reduce="(row) => row.status">
            <span slot="no-options">Eşleşen Veri Yok</span>
          </v-select>
        </div>
        <div class="vx-col md:w-1/5 w-full">
          <label class="text-sm"><b>Form Tür</b></label>
          <v-select @input="getHRManagementList()" class="w-full" placeholder="Form Tür" label="formTypeName" :options="formTypeList" v-model="searchModel.tableName" :reduce="(row) => row.tableName">
            <span slot="no-options">Eşleşen Veri Yok</span>
          </v-select>
        </div>

        <div class="vx-col md:w-1/5 w-full">
          <label class="text-sm"><b>Personel</b></label>
          <v-select @input="getHRManagementList()" class="w-full" placeholder="Form Oluşturan" label="userName" :options="personnalList" v-model="searchModel.formOwnerId" :reduce="(row) => row.userId">
            <span slot="no-options">Eşleşen Veri Yok</span>
          </v-select>
        </div>
        <div class="vx-col md:w-1/5 w-full">
          <label class="text-sm"><b>Başlangıç</b></label>
          <vs-input type="date" class="w-full" size="medium" v-model="searchModel.startDate"></vs-input>
        </div>
        <div class="vx-col md:w-1/5 w-full">
          <label class="text-sm"><b>Bitiş</b></label>
          <vs-input @change="getHRManagementList()" type="date" class="w-full" size="medium" v-model="searchModel.finishDate"></vs-input>
        </div>
      </div>

      <vs-divider />
      <!-- prompt for addnew personnel -->

      <!-- AgGrid Table -->

      <ag-grid-vue
        style="height: 43vh;"
        ref="agGridTable"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="hrManagementList"
        rowSelection="single"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :rowClassRules="rowClassRules"
        :context="context"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import { repository } from "@/_services/repository.js";
import vSelect from "vue-select";
import JsonExcel from "vue-json-excel";

// Cell Renderer
import CellRendererActions from "./managementListCellRenderer/CellRendererActions.vue";

export default {
  components: {
    vSelect,
    AgGridVue,
    CellRendererActions,
    JsonExcel,
  },
  data() {
    return {
      personnalList: [],
      context: null,
      hrManagementList: [],
      permissionList:[],
      searchModel: { startDate: null, finishDate: null, formOwnerId: null, tableName: null, firstApproverId: null, secondApproverId: null, status: null },
      formTypeList: [
        { tableName: "Permission", formTypeName: "İzin" },
        { tableName: "Advance", formTypeName: "Avans" },
        { tableName: "InventoryStockDetail", formTypeName: "Zimmet" },
      ],
      statusList: [
        { status: "T", statusName: "Onay Bekleyen" },
        { status: "O", statusName: "Onaylanmış" },
        { status: "R", statusName: "Reddedilmiş" },
      ],
      delayedSearchTimer: "",
      gridApi: null,
      rowClassRules: null,

      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      /* eslint-disable */
      columnDefs: [
        {
          headerName: "Form Id",
          field: "formId",
          filter: true,
          width: 100,
        },

        {
          headerName: "Personel",
          field: "formOwner",
          filter: true,
          width: 150,
        },

        {
          headerName: "Form Tür",
          field: "formType",
          filter: true,
          width: 100,
        },

        {
          headerName: "Durum",
          field: "statusDescription",
          filter: true,
          width: 150,
        },
        {
          headerName: "Tarih",
          field: "date",
          sort: "desc",
          filter: true,
          width: 150,
        },

        {
          headerName: "Onaylayan",
          field: "firstApprover",
          filter: true,
          width: 100,
        },

        {
          headerName: "Açıklama",
          field: "description",
          width: 200,
        },
        {
          headerName: "İşlem",
          field: "transactions",
          width: 50,
          cellRendererFramework: "CellRendererActions",
        },
      ],
    };
  },

  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 12;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  created() {
    this.getHRManagementList();
    this.getUsers();
    this.getPermissions();
    
  },
  methods: {
    getUsers: async function() {
      await repository.getAll("User/getUserList").then((r) => {
        this.personnalList = r.list;
      });

      return this.personnalList;
    },
    getPermissions: async function() {
      this.permissionList=await repository.postEntity("HumanResource/GetPermission",this.searchModel).then((r) => r.list);  
      console.log("aassa",this.permissionList)
      return this.permissionList;
      
    },

    methodFromParent() {
      alert("test");
    },

    getHRManagementList: async function() {
      this.$vs.loading();
      let list = await repository.postEntity("humanResource/getHRManagement", this.searchModel).then((r) => r.list);

      this.$vs.loading.close();

      //avans modülü için girilen avansı sadece yetkililer görmeli
      //muhasebe süper admin yöneticisi
      if (list) {
        if (this.$store.state.userData.authorizationList.find((f) => f.authorizationId == "4") != null || this.$store.state.userData.departmentId == 3) {
        } else {
          list = list.filter((row) => row.tableName != "Advance" || row.formOwnerId == this.$store.state.userData.userId || row.managerUserId == this.$store.state.userData.userId);
        }
        this.hrManagementList = list;
      } else {
        this.$vs.notify({
          title: "Liste Çekilemedi",
          text: (list && list.hasExceptionError && list.exceptionMessage) || "bilinmeyen hata oluştu.",
          color: "danger",
          icon: "warning",
        });
      }
    },
  },

  beforeMount() {
    this.rowClassRules = {};
    this.context = { componentParent: this };
  },
  beforeUpdate() {
    this.gridApi.sizeColumnsToFit();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;

    this.gridApi.sizeColumnsToFit();
  },
};
</script>

<style lang="scss" scoped></style>
